<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/There_Was_a_Crooked_Man2#Contents-A">Dedication</a></p>
<p class="Body-Center para-style-override-3"><span class="Italic">This one is for sisters everywhere.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// There_Was_a_Crooked_Man-3.vue?33ab8940